import React from "react";
import { Navbar } from "./components/navbar";
import { Hero } from "./components/hero";
import { FeaturedProducts } from "./components/featured-products";
import { AboutSection } from "./components/about-section";
import { PartnersSection } from "./components/partners-section";
import { NewsSection } from "./components/news-section";
import { Footer } from "./components/footer";
import { CartModal } from "./components/cart-modal";
import { NotificationPopup } from "./components/notification-popup";
import { PartnersPage } from "./pages/partners-page";
import { PartnersGiftsPage } from "./pages/partners-gifts-page";
import { ProductPage } from "./pages/product-page";
import { AboutUsPage } from "./pages/about-us-page";
import { AuthPage } from "./pages/auth-page";
import RegisterPage from "./pages/register-page";
import RegisterConfirmationPage from './pages/register-confirmation-page';
import ConfirmEmailPage from './pages/confirm-email-page';
import { ProductDetailPage } from "./pages/product-detail-page";
import { CheckoutPage } from "./pages/checkout-page";
// import { CheckoutPageModern } from "./pages/checkout-page-modern";
import PayStatusPage from './pages/pay-status-page';
import { PrivacyPolicyPage } from "./pages/privacy-policy-page";
import { TermsPage } from "./pages/terms-page";
import { AccountPage } from "./pages/account-page";
import { PartnersLogos } from "./components/partners-logos";
import { NewsListPage } from "./pages/news-list-page";
import { NewsDetailPage } from "./pages/news-detail-page";
import { CatalogPage } from "./pages/catalog-page";
import { ProductsOverviewPage } from "./pages/products-overview-page";
import SearchPage from "./pages/search-page";
import { CookieConsent } from "./components/cookie-consent";
import { ShippingPage } from "./pages/shipping-page";
import { ReturnsPage } from "./pages/returns-page";
import { ContactsPage } from "./pages/contacts-page";
import StoreAddressesPage from './pages/store-addresses-page';
import YandexCallbackPage from "./pages/yandex-callback-page";
import { useAuth } from "./contexts/auth-context";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { ScrollToTop } from "./components/scroll-to-top";
import { motion, AnimatePresence } from "framer-motion";
import { CartProvider } from "./contexts/cart-context";
// import { Analytics } from "./components/analytics"; // Раскомментируйте для использования компонента аналитики
import { AromaServicesPage } from "./pages/aroma-services-page";
// import GiftCardPage from "./pages/gift-card-page";
import NotFoundPage from "./pages/not-found-page";
import { Helmet } from 'react-helmet-async';

export default function App() {
  const [isCartOpen, setIsCartOpen] = React.useState(false);
  const [showNotification, setShowNotification] = React.useState(false);
  const [notificationMessage, setNotificationMessage] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState("home");
  const [selectedCategory, setSelectedCategory] = React.useState<string | null>(null);
  const [selectedProductId, setSelectedProductId] = React.useState<number | null>(null);
  const [selectedProduct, setSelectedProduct] = React.useState<string | null>(null);
  const [accountSection, setAccountSection] = React.useState("profile");
  const [selectedNewsId, setSelectedNewsId] = React.useState<string | null>(null);
  const [selectedProductDetail, setSelectedProductDetail] = React.useState<number | null>(null);
  const [showCookieConsent, setShowCookieConsent] = React.useState(true);
  const [sourceCategory, setSourceCategory] = React.useState("каталогу");

  // Get auth context for protected routes
  const { isAuthenticated, isLoading } = useAuth();

  const history = useHistory(); // Change from navigate to history
  const location = useLocation();

  // Use useEffect to track current page from URL
  React.useEffect(() => {
    const path = location.pathname;
    if (path === '/') {
      setCurrentPage('home');
    } else {
      // Extract current page from path
      const pageName = path.split('/')[1];
      if (pageName) {
        setCurrentPage(pageName);
      }
      
      // Extract productType from URL if present
      const productMatch = path.match(/\/product\/([^/]+)/);
      if (productMatch && productMatch[1]) {
        setSelectedProduct(productMatch[1]);
      }
      
      // Extract news ID from URL if present
      const newsMatch = path.match(/\/news-detail\/([^/]+)/);
      if (newsMatch && newsMatch[1]) {
        setSelectedNewsId(newsMatch[1]);
      }
    }
  }, [location]);

  // Add a debug effect to verify cart persistence on mount
  React.useEffect(() => {
    try {
      const savedCart = localStorage.getItem('safonova_cart');
      if (savedCart) {
        const parsedCart = JSON.parse(savedCart);
        console.debug(`Cart loaded on app initialization: ${parsedCart.length} items`);
      }
    } catch (error) {
      console.error('Error checking cart in localStorage:', error);
    }
  }, []);

  const handleOpenCart = () => {
    setIsCartOpen(true);
  };

  const handleCloseCart = () => {
    setIsCartOpen(false);
  };

  const handleAddToCart = (productName: string) => {
    setNotificationMessage(`${productName} добавлен в корзину`);
    setShowNotification(true);
    
    setTimeout(() => {
      setShowNotification(false);
    }, 3000);
  };

  // Add the missing handleNavigation function
  const handleNavigation = (page: string, productType?: string) => {
    if (page === 'home') {
      history.push('/'); // Change navigate to history.push
    } else if (page === 'product' && productType) {
      history.push(`/product/${productType}`); // Change navigate to history.push
    } else if (page === 'news-detail' && selectedNewsId) {
      history.push(`/news-detail/${selectedNewsId}`); // Change navigate to history.push
    } else {
      history.push(`/${page}`); // Change navigate to history.push
    }
  };

  // Protected route handler using router
  const handlePageNavigation = (page: string, productType?: string) => {
  // Check if the page requires authentication
  // Note: checkout is intentionally NOT protected anymore — guests can place orders.
  const protectedPages = ["account"];
    
    if (protectedPages.includes(page) && !isAuthenticated) {
      // Redirect to auth page if trying to access protected pages without authentication
      history.push('/auth'); // Change navigate to history.push
      setNotificationMessage("Пожалуйста, войдите в систему для доступа к этой странице");
      setShowNotification(true);
      
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
      return;
    }
    
    handleNavigation(page, productType);
  };

  // React.useEffect(() => {
  //   // Show welcome notification after 3 seconds
  //   const timer = setTimeout(() => {
  //     setNotificationMessage("Добро пожаловать в наш магазин SAFONOVA!"); // Changed from generic welcome message
  //     setShowNotification(true);
      
  //     setTimeout(() => {
  //       setShowNotification(false);
  //     }, 3000);
  //   }, 3000);
    
  //   return () => clearTimeout(timer);
  // }, []);

  React.useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted') === 'true';
    if (cookiesAccepted) {
      setShowCookieConsent(false);
    }
  }, []);

  const handleAcceptCookies = React.useCallback(() => {
    setShowCookieConsent(false);
    // In a real app, you might want to store this preference in localStorage
    localStorage.setItem('cookiesAccepted', 'true');
  }, []);

  // Page transition variants
  const pageTransitionVariants = {
    initial: {
      opacity: 0,
      y: 10,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: [0.16, 1, 0.3, 1],
        when: "beforeChildren",
      }
    },
    exit: {
      opacity: 0,
      y: -10,
      transition: {
        duration: 0.2,
      }
    }
  };

  // Show loading state if checking authentication (only on client, чтобы SSR всегда видел дерево маршрутов и Helmet)
  const isBrowser = typeof window !== 'undefined';

  if (isBrowser && isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="mb-4">
            <div className="w-16 h-16 mx-auto">
              <svg className="animate-spin text-primary" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
          </div>
          <p className="text-foreground/70">Загрузка...</p>
        </div>
      </div>
    );
  }

  return (
    <CartProvider>
      <div className="min-h-screen flex flex-col">
        <ScrollToTop />
        {/* Место для компонента аналитики:
        <Analytics 
          yandexCounterId="XXXXXXXX" 
          googleAnalyticsId="G-XXXXXXXXXX" 
        /> */}
        <Navbar 
          onCartClick={handleOpenCart} 
          currentPage={currentPage}
          onPageChange={handlePageNavigation}
          onProductTypeSelect={setSelectedProduct}
        />
        <AnimatePresence mode="wait">
          <motion.main 
            key={location.pathname}
            className="flex-grow"
            initial="initial"
            animate="animate"
            exit="exit"
            variants={pageTransitionVariants}
          >
            <Switch location={location}>
              <Route exact path="/" render={() => (
                <>
                  <Helmet>
                    <title>SAFONOVA — премиальная ароматическая продукция ручной работы</title>
                    <meta name="description" content="Премиальные свечи, саше, мелтс, диффузоры и автопарфюмы. Мы создаём уникальную атмосферу для дома и бизнеса." />
                    <meta property="og:title" content="SAFONOVA — премиальная ароматическая продукция ручной работы" />
                    <meta property="og:description" content="Премиальные свечи, саше, мелтс, диффузоры и автопарфюмы. Мы создаём уникальную атмосферу для дома и бизнеса." />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://safonova-brand.ru/" />
                    <meta property="og:image" content="https://safonova-brand.ru/og-default.png" />
                  </Helmet>
                  <Hero />
                  <FeaturedProducts 
                    onAddToCart={handleAddToCart} 
                    onProductSelect={(type) => {
                      setSelectedProduct(type);
                      history.push(`/product/${type}`);
                    }}
                  />
                  <AboutSection onViewMoreClick={() => history.push("/about")} />
                  <PartnersLogos onViewMoreClick={() => history.push("/partners")} />
                  <PartnersSection onViewMoreClick={() => history.push("/partners")} />
                  <NewsSection 
                    onViewAllClick={() => history.push("/news-list")}
                    onNewsItemClick={(newsId) => {
                      setSelectedNewsId(String(newsId));
                      history.push(`/news-detail/${newsId}`);
                    }}
                  />
                </>
              )} />
              <Route path="/auth/yandex/callback" render={() => <YandexCallbackPage />} />
              <Route exact path="/auth" render={() => <AuthPage onLogin={() => history.push("/account")} />} />
              <Route path="/register" render={() => <RegisterPage />} />
              <Route path="/register/confirmation" render={() => <RegisterConfirmationPage />} />
              <Route path="/confirm-email" render={() => <ConfirmEmailPage />} />
              <Route path="/account" render={() => 
                isAuthenticated ? 
                  <AccountPage 
                    activeSection={accountSection}
                    onSectionChange={setAccountSection}
                  /> : 
                  <AuthPage onLogin={() => history.push("/account")} />
              } />
              <Route path="/checkout" render={() => (
                // Allow unauthenticated users to access checkout
                <CheckoutPage />
              )} />
              <Route path="/paystatus" render={() => <PayStatusPage />} />
              <Route path="/contacts" render={() => <ContactsPage />} />
              <Route path="/store-addresses" render={() => <StoreAddressesPage />} />
              <Route path="/search" render={() => <SearchPage />} />
              <Route path="/catalog/:categoryKey?" render={() =>
                <CatalogPage 
                  onCategorySelect={setSelectedCategory}
                  onProductSelect={(productId) => {
                    setSelectedProductDetail(productId);
                    history.push(`/product-detail/${productId}`);
                  }}
                  onAddToCart={handleAddToCart}
                />
              } />
              <Route path="/products" render={() =>
                <ProductsOverviewPage 
                  onCategorySelect={(category) => {
                    setSelectedCategory(category);
                    history.push(`/catalog/${category}`);
                  }}
                />
              } />
              <Route path="/product/:productType" render={() =>
                <ProductPage 
                  productType={selectedProduct || ''} 
                  onAddToCart={handleAddToCart}
                  onProductSelect={(productId) => {
                    setSelectedProductDetail(productId);
                    history.push(`/product-detail/${productId}`);
                  }}
                />
              } />
              <Route path="/product-detail/:productIdOrSlug" render={(routeProps: any) =>
                <ProductDetailPage 
                  productId={routeProps.match?.params?.productIdOrSlug || selectedProductDetail || 0}
                  onAddToCart={handleAddToCart}
                  onGoBack={() => history.goBack()}
                  sourceCategory={sourceCategory}
                />
              } />
              <Route path="/news-list" render={() =>
                <NewsListPage 
                  onNewsSelect={(newsId) => {
                    setSelectedNewsId(String(newsId));
                    history.push(`/news-detail/${newsId}`);
                  }} 
                />
              } />
              <Route path="/news-detail/:newsId" render={() =>
                <NewsDetailPage 
                  newsId={selectedNewsId || ''}
                  onGoBack={() => history.goBack()}
                />
              } />
              <Route path="/partners" render={() => <PartnersPage />} />
              <Route path="/about" render={() =>
                <AboutUsPage onProductTypeSelect={(type) => {
                  setSelectedProduct(type);
                  history.push(`/product/${type}`);
                }} />
              } />
              <Route path="/privacy" render={() => <PrivacyPolicyPage />} />
              <Route path="/terms" render={() => <TermsPage />} />
              <Route path="/shipping" render={() => <ShippingPage />} />
              <Route path="/returns" render={() => <ReturnsPage />} />
              <Route path="/partners-gifts" render={() => <PartnersGiftsPage />} />
              <Route path="/aroma-services" render={() => <AromaServicesPage />} />
              {/* <Route path="/gift-card" render={() => <GiftCardPage />} /> */}
              {/* Catch-all 404 route: set staticContext.status = 404 on server */}
              <Route render={(props: any) => {
                if (props && props.staticContext) props.staticContext.status = 404;
                return <NotFoundPage {...props} />
              }} />
            </Switch>
          </motion.main>
        </AnimatePresence>
        <Footer currentPage={currentPage} onPageChange={handlePageNavigation} />
        <CartModal 
          isOpen={isCartOpen} 
          onClose={handleCloseCart} 
          onCheckout={() => {
            handleCloseCart();
            handlePageNavigation("checkout"); // Use the protected route handler
          }} 
        />
        <NotificationPopup 
          show={showNotification} 
          message={notificationMessage} 
          onClose={() => setShowNotification(false)} 
        />
        <CookieConsent
          show={showCookieConsent}
          onAccept={handleAcceptCookies}
        />
      </div>
    </CartProvider>
  );
}